import { Drawer } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { InvoiceLateFee } from '@features/transactions/query-api'

import { useInvoice } from '../../../../../../../invoices/'
import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { BookingsSection } from '../../elements/BookingsSection/BookingsSection'
import { DetailsSection } from '../../elements/DetailsSection'
import { HeroSection } from '../../elements/HeroSection'
import { Separator } from '../../elements/Separator'
import { TransactionDrawerSkeleton } from '../../elements/TransactionDrawerSkeleton'

interface InvoiceLateFeeViewProps {
  invoiceLateFee: InvoiceLateFee
}

export const InvoiceLateFeeView = ({ invoiceLateFee }: InvoiceLateFeeViewProps) => {
  const { t } = useTranslation()
  const { transactionNo } = useTransactionDrawerContext()

  const { amount, createdTime, entryDate, invoiceId } = invoiceLateFee

  const { data: invoiceData, isLoading } = useInvoice(invoiceId)

  if (isLoading || !invoiceData) {
    return <TransactionDrawerSkeleton transactionNo={transactionNo} />
  }
  const {
    invoice: { currencyId, invoiceNo },
    contacts,
  } = invoiceData

  return (
    <>
      <Drawer.Header closable title={t('ledger.drawer_title', { number: transactionNo })} />
      <Drawer.Body withPadding={false} gap="0">
        <HeroSection
          amount={amount}
          contactName={contacts?.[0].name}
          currency={currencyId}
          entryDate={entryDate}
          source={t('ledger.invoice_no', { number: invoiceNo })}
        />
        <Separator />
        <BookingsSection originatorCurrency={currencyId} />
        <Separator />
        <DetailsSection createdTime={createdTime} />
        <Separator />
      </Drawer.Body>
    </>
  )
}
